import { Button, Form } from "reactstrap";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faSave, faTimes } from "@fortawesome/free-solid-svg-icons";

export default function ModalFormUlangan({
  show,
  onHide,
  editUlanganId,
  formUlangan,
  handleChangeFormUlangan,
  handleSubmitUlangan,
  isSubmittingUlangan,
  selectedMatpel,
  currentCpData,
  tpDataByCp,
  isFetchingTp,
  learningTypeData,
  isFetchingLearningType,
  handleChangeTpUlangan,
  handleChangeKelasUlangan,
  handleSelectAllKelasUlangan,
  handleChangeJadwalKelasUlangan,
}) {
  const tpOptions =
    formUlangan.ysb_matpel_cp_id &&
    tpDataByCp?.[formUlangan.ysb_matpel_cp_id]
      ? tpDataByCp[formUlangan.ysb_matpel_cp_id]
      : [];

  const selectedTpIds = Array.isArray(formUlangan.ysb_matpel_tp_ids)
    ? formUlangan.ysb_matpel_tp_ids
    : [];

  const selectedKelas = Array.isArray(formUlangan.ysb_kelas_id)
    ? formUlangan.ysb_kelas_id
    : [];

  const kelasList = selectedMatpel?.kelas_list || [];

  const isAllKelasSelected =
    kelasList.length > 0 &&
    kelasList
      .map((kelas) => kelas?.ysb_kelas_id)
      .filter(Boolean)
      .every((kelasId) => selectedKelas.includes(kelasId));

  const getJadwalKelas = (kelasId) => {
    const items = Array.isArray(formUlangan.items) ? formUlangan.items : [];

    return (
      items.find((item) => String(item?.ysb_kelas_id) === String(kelasId)) || {
        ysb_kelas_id: kelasId,
        date_exam: "",
        time_exam: "",
      }
    );
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="modal-ulangan"
      centered
      backdrop="static"
      keyboard={false}
    >
      <div className="d-flex header-modal">
        <h5>{editUlanganId ? "Update Ulangan" : "Buat Ulangan"}</h5>

        <div className="ml-auto x-close">
          <FontAwesomeIcon icon={faTimes} onClick={onHide} />
        </div>
      </div>

      <hr />

      <Modal.Body className="modal-body">
        <Form onSubmit={(e) => handleSubmitUlangan(e, false)}>
          <div className="row">
            <div className="col-md-12">
              <div className="mt-3 label-group-form">
                <label className="label-name-form">Judul</label>
                <input
                  className="label-input-form"
                  autoFocus
                  type="text"
                  name="title"
                  placeholder="Masukkan judul ulangan"
                  value={formUlangan.title}
                  onChange={handleChangeFormUlangan}
                  disabled={isSubmittingUlangan}
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="mt-4 label-group-form">
                <label className="label-name-form">Tipe Ulangan</label>
                <select
                  className="label-input-form"
                  name="ysb_learning_type_id"
                  value={formUlangan.ysb_learning_type_id}
                  onChange={handleChangeFormUlangan}
                  disabled={isSubmittingUlangan || isFetchingLearningType}
                >
                  <option value="">
                    {isFetchingLearningType ? "Memuat tipe..." : "Pilih tipe"}
                  </option>

                  {(learningTypeData || []).map((type) => (
                    <option key={type.id} value={type.id}>
                      {type.name_learning}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-md-6">
              <div className="mt-4 label-group-form">
                <label className="label-name-form">CP</label>
                <select
                  className="label-input-form"
                  name="ysb_matpel_cp_id"
                  value={formUlangan.ysb_matpel_cp_id}
                  onChange={handleChangeFormUlangan}
                  disabled={isSubmittingUlangan}
                >
                  <option value="">Pilih CP</option>
                  {(currentCpData || []).map((cp) => (
                    <option key={cp.id} value={cp.id}>
                      {cp.nama_cp}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            

            <div className="col-md-12">
              <div className="mt-4">
                <label
                  style={{
                    color: "#374151",
                    fontWeight: 700,
                    marginBottom: 10,
                    display: "block",
                  }}
                >
                  TP
                </label>

                <div
                  style={{
                    border: "1px solid #9bb5ff",
                    borderRadius: 12,
                    padding: "12px 14px",
                    minHeight: 52,
                    background: "#fff",
                  }}
                >
                  {isFetchingTp ? (
                    <div
                      style={{
                        color: "#6b7280",
                        fontWeight: 600,
                        fontSize: 13,
                      }}
                    >
                      Memuat TP...
                    </div>
                  ) : tpOptions.length > 0 ? (
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fit, minmax(220px, 1fr))",
                        gap: 10,
                      }}
                    >
                      {tpOptions.map((tp) => {
                        const isChecked = selectedTpIds.includes(tp.id);

                        return (
                          <label
                            key={tp.id}
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                              gap: 8,
                              marginBottom: 0,
                              color: isChecked ? "#3f5bea" : "#374151",
                              fontWeight: 600,
                              cursor: isSubmittingUlangan
                                ? "not-allowed"
                                : "pointer",
                              lineHeight: 1.4,
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={isChecked}
                              onChange={() => handleChangeTpUlangan(tp.id)}
                              disabled={isSubmittingUlangan}
                              style={{ marginTop: 3 }}
                            />

                            <span>
                              <span>{tp.tp || "-"}</span>

                              {tp.keterangan ? (
                                <small
                                  style={{
                                    display: "block",
                                    color: "#6b7280",
                                    fontWeight: 500,
                                  }}
                                >
                                  {tp.keterangan}
                                </small>
                              ) : null}
                            </span>
                          </label>
                        );
                      })}
                    </div>
                  ) : (
                    <div
                      style={{
                        color: "#6b7280",
                        fontWeight: 600,
                        fontSize: 13,
                      }}
                    >
                      TP belum tersedia. Pilih CP terlebih dahulu.
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="col-md-12">
              <div className="mt-4">
                <div
                  className="d-flex"
                  style={{
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 10,
                    marginBottom: 10,
                  }}
                >
                  <label
                    style={{
                      color: "#374151",
                      fontWeight: 700,
                      marginBottom: 0,
                    }}
                  >
                    Kelas dan Jadwal
                  </label>

                  {(selectedMatpel?.kelas_list || []).length > 0 && (
                    <button
                      type="button"
                      onClick={handleSelectAllKelasUlangan}
                      disabled={isSubmittingUlangan}
                      style={{
                        border: "none",
                        background: "transparent",
                        color: "#3f5bea",
                        fontWeight: 700,
                        fontSize: 13,
                        cursor: isSubmittingUlangan
                          ? "not-allowed"
                          : "pointer",
                      }}
                    >
                      {isAllKelasSelected ? "Batal Pilih Semua" : "Pilih Semua"}
                    </button>
                  )}
                </div>

                <div
                  style={{
                    border: "1px solid #9bb5ff",
                    borderRadius: 12,
                    padding: "12px 14px",
                    minHeight: 52,
                    background: "#fff",
                  }}
                >
                  {(selectedMatpel?.kelas_list || []).length > 0 ? (
                    <div style={{ display: "grid", gap: 12 }}>
                      {(selectedMatpel?.kelas_list || []).map((kelas, index) => {
                        const kelasId = kelas?.ysb_kelas_id || "";
                        const isChecked = selectedKelas.includes(kelasId);
                        const jadwal = getJadwalKelas(kelasId);

                        return (
                          <div
                            key={kelasId || index}
                            style={{
                              border: isChecked
                                ? "1px solid #9bb5ff"
                                : "1px solid #e5e7eb",
                              borderRadius: 12,
                              padding: 12,
                              background: isChecked ? "#f8fbff" : "#fff",
                            }}
                          >
                            <label
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                                marginBottom: isChecked ? 12 : 0,
                                color: isChecked ? "#3f5bea" : "#374151",
                                fontWeight: 700,
                                cursor: isSubmittingUlangan
                                  ? "not-allowed"
                                  : "pointer",
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={() =>
                                  handleChangeKelasUlangan(kelasId)
                                }
                                disabled={isSubmittingUlangan || !kelasId}
                              />

                              {kelas?.nama_kelas ||
                                kelas?.name_kelas ||
                                kelas?.kelas_name ||
                                "-"}
                            </label>

                            {isChecked && (
                              <div className="row">
                                <div className="col-md-6">
                                  <label
                                    style={{
                                      fontSize: 12,
                                      fontWeight: 700,
                                      color: "#6b7280",
                                      marginBottom: 6,
                                    }}
                                  >
                                    Tanggal Ulangan
                                  </label>

                                  <input
                                    className="label-input-form"
                                    type="date"
                                    value={jadwal.date_exam || ""}
                                    onChange={(e) =>
                                      handleChangeJadwalKelasUlangan(
                                        kelasId,
                                        "date_exam",
                                        e.target.value
                                      )
                                    }
                                    disabled={isSubmittingUlangan}
                                  />
                                </div>

                                <div className="col-md-6">
                                  <label
                                    style={{
                                      fontSize: 12,
                                      fontWeight: 700,
                                      color: "#6b7280",
                                      marginBottom: 6,
                                    }}
                                  >
                                    Jam Ulangan
                                  </label>

                                  <input
                                    className="label-input-form"
                                    type="time"
                                    value={jadwal.time_exam || ""}
                                    onChange={(e) =>
                                      handleChangeJadwalKelasUlangan(
                                        kelasId,
                                        "time_exam",
                                        e.target.value
                                      )
                                    }
                                    disabled={isSubmittingUlangan}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <div
                      style={{
                        color: "#6b7280",
                        fontWeight: 600,
                        fontSize: 13,
                      }}
                    >
                      Kelas belum tersedia
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="mt-4">
                <label style={{ fontWeight: 700, color: "#374151" }}>
                  Diskusi
                </label>

                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    marginTop: 8,
                    color: "#3f5bea",
                    fontWeight: 700,
                  }}
                >
                  <input
                    type="checkbox"
                    name="discuss"
                    checked={formUlangan.discuss}
                    onChange={handleChangeFormUlangan}
                    disabled={isSubmittingUlangan}
                  />
                  Dibuka
                </label>
              </div>
            </div>

            <div className="col-md-3">
              <div className="mt-4">
                <label style={{ fontWeight: 700, color: "#374151" }}>
                  Notifikasi
                </label>

                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    marginTop: 8,
                    color: "#3f5bea",
                    fontWeight: 700,
                  }}
                >
                  <input
                    type="checkbox"
                    name="notofication"
                    checked={formUlangan.notofication}
                    onChange={handleChangeFormUlangan}
                    disabled={isSubmittingUlangan}
                  />
                  Ya
                </label>
              </div>
            </div>

            <div className="col-md-3">
              <div className="mt-4">
                <label style={{ fontWeight: 700, color: "#374151" }}>
                  Tersembunyi
                </label>

                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    marginTop: 8,
                    color: "#3f5bea",
                    fontWeight: 700,
                  }}
                >
                  <input
                    type="checkbox"
                    name="hide_exam"
                    checked={formUlangan.hide_exam}
                    onChange={handleChangeFormUlangan}
                    disabled={isSubmittingUlangan}
                  />
                  Ya
                </label>
              </div>
            </div>

            <div className="col-md-3">
              <div className="mt-4">
                <label style={{ fontWeight: 700, color: "#374151" }}>
                  Sembunyikan Nilai
                </label>

                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    marginTop: 8,
                    color: "#3f5bea",
                    fontWeight: 700,
                  }}
                >
                  <input
                    type="checkbox"
                    name="hide_exam_value"
                    checked={formUlangan.hide_exam_value}
                    onChange={handleChangeFormUlangan}
                    disabled={isSubmittingUlangan}
                  />
                  Ya
                </label>
              </div>
            </div>

            <div className="mt-3 col-md-12">
              <div className="mt-3 label-group-form">
                <label className="label-name-form">Keterangan</label>
                <input
                  className="label-input-form"
                  type="text"
                  name="description"
                  placeholder="Masukkan keterangan"
                  value={formUlangan.description}
                  onChange={handleChangeFormUlangan}
                  disabled={isSubmittingUlangan}
                />
              </div>
            </div>

            <div className="col-md-12">
              <div className="mt-4 label-group-form">
                <label className="label-name-form">File Ulangan Harian</label>
                <input
                  className="label-input-form"
                  type="file"
                  name="file_exam"
                  onChange={handleChangeFormUlangan}
                  disabled={isSubmittingUlangan}
                />
              </div>
            </div>
          </div>

          <div
            className="d-flex mt-4"
            style={{
              justifyContent: "flex-end",
              gap: 10,
              flexWrap: "wrap",
            }}
          >
            <Button
              type="button"
              className="btn btn-light"
              onClick={onHide}
              disabled={isSubmittingUlangan}
              style={{
                borderRadius: 10,
                fontWeight: 600,
                padding: "8px 14px",
              }}
            >
              Batal
            </Button>

            <Button
              className="btn-modal-create"
              type="submit"
              disabled={isSubmittingUlangan}
              style={{
                borderRadius: 12,
                padding: "8px 14px",
                boxShadow: "0 10px 24px rgba(108,99,255,0.18)",
                fontWeight: 600,
              }}
            >
              {isSubmittingUlangan ? (
                <>
                  <i className="fa fa-spinner fa-spin mr-2" />
                  Menyimpan...
                </>
              ) : (
                <>
                  <FontAwesomeIcon icon={editUlanganId ? faSave : faPlus} />{" "}
                  {editUlanganId ? "Perbarui" : "Tambahkan"}
                </>
              )}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}